module.exports = __webpack_public_path__ + "static/media/member_offers.3efd620a.svg";